export type OmitNested<T, K extends keyof T, P extends keyof T[K]> = Omit<T, K> & {
  [Key in K]: Omit<T[Key], P>;
};
